// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"629ce07e","115":"7e05a13d","116":"16ca2ca5","305":"105e9550","379":"e9475f9e","861":"d85fa547","960":"e5e84f16"}[chunkId] + ".css";
};